define('modules/integrations/services/api/index',['require','exports','module','./view','./model','./collection'],function(require, exports, module) {
    'use strict';

    module.exports = {
        View: require('./view'),
        Model: require('./model'),
        Collection: require('./collection')
    };

});

